// src/playback-runtime/platform/usePlaybackPlatform.ts

"use client";

/*
 Central playback runtime integration
 This is the bridge between players and browser environment
*/

import { usePlaybackArbitration } from "../arbitration/usePlaybackArbitration";
import { useBackgroundAudioGuard } from "../lifecycle/useBackgroundAudioGuard";
import { useAudioContextKeepAlive } from "../lifecycle/useAudioContextKeepAlive";
import { useAutoResume } from "../lifecycle/useAutoResume";
import { useSmartPrebuffer } from "../buffering/useSmartPrebuffer";

type Options = {
  src?: string | null;
};

export function usePlaybackPlatform(
  audioRef: React.RefObject<HTMLAudioElement | null>,
  options: Options
) {
  const src = options.src ?? null;

  // always needed (player arbitration)
  usePlaybackArbitration(audioRef);

  // always needed
  useBackgroundAudioGuard(audioRef);

  // always needed
  useAudioContextKeepAlive();

  // ------------------------------------
  // Below features require a real media URL
  // ------------------------------------
  if (src) {
    useAutoResume(audioRef, { src });
    useSmartPrebuffer(audioRef, { src });
  }
}